/**
 * The address "Prepare the offer" of the assistant's panel leads to (api#425): the car's page with
 * the delivery offer started — `/listing/:id?offer=delivery&point=<delivery point id>`, the point
 * only when the person named a city the platform delivers to. The page opens the "Buy with
 * Delivery" form once the buyer's gate is passed (an account with a linked wallet, a car that can
 * still be bought) and preselects the city when the form's own list has it; the recipient stays
 * the person's to fill in, and "Send offer" is the person's click. Nothing in the address can
 * create, pay or sign anything.
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const OFFER_QUERY = 'offer';
export const OFFER_DELIVERY = 'delivery';
export const POINT_QUERY = 'point';

/** The address of a car's page with the delivery offer started, the city filled in when known. */
export const offerPathWithPoint = (listingId: string, deliveryPointId: string | null): string => {
  const base = `/listing/${encodeURIComponent(listingId)}?${OFFER_QUERY}=${OFFER_DELIVERY}`;

  return deliveryPointId ? `${base}&${POINT_QUERY}=${encodeURIComponent(deliveryPointId)}` : base;
};

/** What the car's page reads from its address: whether to start the delivery offer, and with which point. */
export const offerFromSearch = (search: URLSearchParams): { delivery: boolean; pointId: string | null } => {
  const delivery = search.get(OFFER_QUERY) === OFFER_DELIVERY;
  const point = search.get(POINT_QUERY) ?? '';

  return { delivery, pointId: delivery && UUID.test(point) ? point : null };
};
